import { ID } from '..';
import { RecursiveListOptions } from '../../interfaces/options';
import { SelectionMode } from '../../enums/selectionMode';
import { ListProperty } from '../../models/listProperty';

export const DefaultRecursiveListOptions: RecursiveListOptions = {
	dataSource: {
		paging: true,
		root: null,
		types: null
	},
	selectionMode: SelectionMode.MULTIPLE,
	// wouldn't build without <any>
	//propertyModel: ListProperty,
	propertyModel: <any>ListProperty,
	idProperty: ID.ID
};
